// Shared shapes for the DATA 360 commercial FAQ. Content lives in the sibling
// faq*.ts files, one file per theme; this file holds only the types and the
// status labels the page and the PDF both render.

// How settled an answer is. The FAQ is read by sales, so an answer that is a
// recommendation rather than an agreed position has to say so on its face.
export type AnswerStatus = 'decided' | 'proposed' | 'open';

export interface StatusMeta {
  label: string;
  // Short line explaining what the status means, shown in the page legend.
  meaning: string;
}

export const STATUS_META: Record<AnswerStatus, StatusMeta> = {
  decided: {
    label: 'Set in the model',
    meaning: 'Already built into the pricing model or the contract terms.',
  },
  proposed: {
    label: 'Recommended',
    meaning: 'A recommended position that still needs sign-off.',
  },
  open: {
    label: 'Open decision',
    meaning: 'Not decided. Needs a call before it can be quoted or promised.',
  },
};

export interface FaqItem {
  id: string;
  question: string;
  status: AnswerStatus;
  // Body paragraphs, rendered in order.
  answer: string[];
  // Optional bullet list rendered after the paragraphs.
  bullets?: string[];
  // Optional closing note: where the answer comes from, or what is still missing.
  note?: string;
}

export interface FaqSection {
  id: string;
  title: string;
  intro: string;
  items: FaqItem[];
}
